import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "@/components/Navbar";
import HeroSection from "@/components/HeroSection";
import StorySection from "@/components/StorySection";
import ProductCarousel from "@/components/ProductCarousel";
import RiceGuide from "@/components/RiceGuide";
import Testimonials from "@/components/Testimonials";
import Newsletter from "@/components/Newsletter";
import ChatWidget from "@/components/ChatWidget";
import Footer from "@/components/Footer";
import AdminPanel from "@/components/AdminPanel";

const LandingPage = () => (
  <div className="font-body">
    <Navbar />
    <HeroSection />
    <StorySection />
    <ProductCarousel />
    <RiceGuide />
    <Testimonials />
    <Newsletter />
    <Footer />
    <ChatWidget />
  </div>
);

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/admin" element={<AdminPanel />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
